const parseDate = (dateString) => {
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
    var parts = dateString?.split(' ');
    var day = parseInt(parts[0]);
    var monthIndex = months.indexOf(parts[1]);
    var year = parseInt(parts[2]);
    return new Date(year, monthIndex, day);
}

const convertToDateTime = (dateString) => {
    const months = {
        Jan: '01', Feb: '02', Mar: '03', Apr: '04',
        May: '05', Jun: '06', Jul: '07', Aug: '08',
        Sept: '09', Oct: '10', Nov: '11', Dec: '12'
    };

    const dateParts = dateString.split(' ');
    const month = months[dateParts[1]];
    const day = dateParts[0];
    const year = dateParts[2];

    return `${year}-${month}-${day}`;
}

const formatDate = (date) => {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-GB', options);
};

const formatDateAsDDMMYY = (dateString) => {
    const date = parseDate(dateString);
    if (!date || isNaN(date)) {
        return 'Invalid Date';
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
};

const formatDateAsDDMMYYHHMM = (dateString) => {
    if (!dateString) return 'NoDate';

    try {
        const date = new Date(dateString);

        // Check if date is valid
        if (isNaN(date.getTime())) return 'InvalidDate';

        // Convert to IST by adding 5 hours and 30 minutes
        const istDate = new Date(date.getTime() + (330 * 60000));

        const year = istDate.getUTCFullYear();
        const month = String(istDate.getUTCMonth() + 1).padStart(2, '0');
        const day = String(istDate.getUTCDate()).padStart(2, '0');
        const hours = String(istDate.getUTCHours()).padStart(2, '0');
        const minutes = String(istDate.getUTCMinutes()).padStart(2, '0');

        return `${year}${month}${day}${hours}${minutes}`;
    } catch (error) {
        console.error('Error formatting date:', error);
        return 'DateError';
    }
}

function parseDateTime(dateStr, timeStr) {
    const m = timeStr.trim().match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?\s*([AP]M)$/i);
    let time24 = '';
    if (m) {
        let hh = parseInt(m[1], 10);
        const mm = m[2];
        const ss = m[3] || '00';
        const ampm = m[4].toUpperCase();
        if (ampm === 'PM' && hh !== 12) hh += 12;
        if (ampm === 'AM' && hh === 12) hh = 0;
        time24 = `${String(hh).padStart(2, '0')}:${mm}:${ss}`;
    } else {
        time24 = timeStr;
    }

    const combined = `${dateStr} ${time24}`;
    const dt = new Date(combined);
    if (isNaN(dt)) {
        return new Date();
    }
    return dt;
}

const sortDateLatest = (dataArray) => {
    dataArray.sort((a, b) => {
        const ta = parseDateTime(a.date, a.time).getTime();
        const tb = parseDateTime(b.date, b.time).getTime();
        return tb - ta;
    });
    return dataArray;
};

const sortObjectByDateTime = (obj) => {
    const entries = Object.entries(obj)
        .filter(([, value]) => value && value.id)
        .sort(([, a], [, b]) => {
            const ta = parseDateTime(a.date, a.time).getTime();
            const tb = parseDateTime(b.date, b.time).getTime();
            return tb - ta;
        });

    const sortedObj = {};
    for (const [key, value] of entries) {
        sortedObj[key] = value;
    }

    return sortedObj;
}

export { parseDate, convertToDateTime, formatDate, formatDateAsDDMMYY, formatDateAsDDMMYYHHMM, sortDateLatest, sortObjectByDateTime };
